import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "order_products",
    object: "order_product",
    header: [
      { text: "ID", value: "id" },
      { text: "Picture", value: "picture" },
      { text: "Name", value: "name" },
      { text: "Quantity", value: "qty" },
      { text: "Confirmed", value: "confirmed" },
      { text: "Price", value: "price" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
